import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from "react-router-dom";
import DocumentMeta from 'react-document-meta';
import Api from './../api/api';
import LoadingBar from 'react-top-loading-bar';

class Home extends React.Component {

    state={
        data:'',
        progress: 0,
        ref:React.createRef(null)
    }

    componentDidMount(){
        const {ref} = this.state;
        // document.title ="Home / Cerafini";
        document.getElementById("fav-icon").href = process.env.PUBLIC_URL + "/CERAFINI_Home.png";
        ref.current.continuousStart(10);

        Api.getHome().then((response) => {
            this.setState({data:response.data});
            ref.current.complete()
        })

        Api.getMetaTags().then( ({data}) => {
            
            const {langTxt} = this.props;
            const {description, tags: keywords} = data.home_tags["content_" + langTxt];

            this.setState({metatags: {
                title: 'Home / Cerafini',
                description,
                meta: {
                  charset: 'utf-8',
                  name: {
                    keywords
                  }
                }
            }});
        });

    }



    createMarkup = (data) => {
        return {__html: data};
    }
    
    renderHeadSection = (data) => {
        const contentPositionMiddle = true;
        const {langTxt} = this.props;
        return (
            <Link to={data.btn_link} className="home-head" style={{backgroundImage: `url(${data.image_url})`}}>
                {(data.visibility)?
                    <div className={`home-head-content ${contentPositionMiddle? 'middle' : 'bottom'}`}>
                        <p>{data["title_" + langTxt]}</p>
                        <h1>{data["secondary_title_" + langTxt]}</h1>
                    </div>
                :''
                }
            </Link>
        )
    }

    renderSection1 = (data) => { 
        const {langTxt} = this.props;

        return <div className="home-section1">
            {(data[0].visibility)?
                <>
                    <div className="home-section1-content">
                        <div className="home-section section-left">
                            <img src={data[1].image_url} alt="home-section-img" />
                            <span dangerouslySetInnerHTML={this.createMarkup(data[1]["image_info_" + langTxt])}/>
                            
                        </div>
                        <div className="home-section section-right">
                            <h1 dangerouslySetInnerHTML={this.createMarkup(data[0]["title_" + langTxt])}/>
                            <p dangerouslySetInnerHTML={this.createMarkup(data[0]["description_" + langTxt])}/>
                            <span dangerouslySetInnerHTML={this.createMarkup(data[2]["image_info_" + langTxt])}/>
                            <img src={data[2].image_url} alt="home-section-img" />
                        </div>
                    </div>
                </>
                :<></>
            }
           
        </div>
    }

    renderSection2 = (data) => { 
        const {langTxt,langUrl} = this.props;

        return (
            <div className="home-section2">
                {(data[0].visibility)?
                    <>
                        <div className="home-section2-desc">
                            <div className="left">
                                <img src={data[1].image_url} alt="home-section-img" />
                            </div>
                            <div className="right">
                                <h1>{data[0]["title_" + langTxt]}</h1>
                                <p>{data[0]["description_" + langTxt]}</p>
                                <div className="btn-wrapper btn-style">
                                    <Link to={langUrl + "/" + data[0].btn_link}>{data[0]["btn_" + langTxt]}</Link>
                                </div>
                            </div>
                        </div>
                        <div className="home-section2-images">
                            <div className="first-img">
                                <img src={data[2].image_url} alt="home-section-img" />
                            </div>
                            <div className="second-img">
                                <img src={data[3].image_url} alt="home-section-img" />
                            </div>
                        </div>
                    </>
                    :<></>
                }
            </div>
        )
    }

    renderSection3 = (data) => {
        const {langTxt,langUrl} = this.props;
        return (
            <Link to={langUrl + "/" + data.btn_link} className="home-section3 cursor-pointer" style={{backgroundImage: `url(${data.image_url})`}}>
                {(data.visibility)?
                    <>
                        <div className="home-section3-content">
                            <h1>{data["title_" + langTxt]}</h1>
                            <p>{data["secondary_title_" + langTxt]}</p>
                        </div>
                    </>
                    :<></>
                }
            </Link>
        )
    }

    renderSection4 = (data)=> {
        const {langTxt} = this.props;
        return(
            <div className="home-section4">
                {(data[0].visibility)?
                    <>
                        <div className="left">
                            <div className="left-text">
                                <h3>{data[0]["title_" + langTxt]}</h3>
                                <p>{data[0]["description_" + langTxt]}</p>
                                <div className="btn-wrapper btn-style">
                                    <Link to={data[0].btn_link}>{data[0]["btn_" + langTxt]}</Link>
                                </div>
                            </div>
                            <div className="left-img">
                                <img src={data[0].image_url} alt=""/>
                            </div>
                        </div>
                        <div className="right">
                            <div className="right-img">
                                <img src={data[1].image_url} alt=""/>
                            </div>
                            <div className="right-text">
                                <h3>{data[1]["title_" + langTxt]}</h3>
                                <p>{data[1]["description_" + langTxt]}</p>
                                <div className="btn-wrapper btn-style">
                                    <Link to={data[1].btn_link}>{data[1]["btn_" + langTxt]}</Link>
                                </div>
                            </div>
                        </div>
                    </>
                    :<></>
                }
            </div>
        )
    }

    renderSection5 = (data) => {
        const {langTxt} = this.props;
        return (
            <div className="home-section5">
                {(data[0].visibility)?
                    <>
                        <div className="left">
                            <img src={data[0].image_url} alt=""/>
                            <p>{data[0]["image_info_" + langTxt]}</p>
                        </div>
                        <div className="right">
                            <p>{data[1]["image_info_" + langTxt]}</p>
                            <img src={data[1].image_url} alt=""/>
                        </div>
                    </>
                    :<></>
                }
            </div>
        )
    }
    renderSection6 = (data) => {
        const {langTxt,langUrl} = this.props;
        const {blog} = data;
        return (
            <div className="home-section6">
                {(data.visibility)?
                    <>
                        <div className="left">
                            <h3>{data["title_" + langTxt]}</h3>
                            <Link to={"/blogs/" + data.blog_id}>{data["secondary_title_" + langTxt]}</Link>
                            <p>{data["description_" + langTxt]}</p>
                        </div>
                        <Link to={langUrl+"/blog/" + blog.id} className="right blog-details">
                            <img src={blog.cover_image} alt="img"/>
                            <div className="blog-details-text">
                                <p className="blog-date">{blog.published_at}</p>
                                <div className="title-read">
                                    <p className="blog-title">{blog["title_" + langTxt]}</p>
                                    <Link className="read-more-btn" to={langUrl+"/blog/" + blog.id}>Read</Link>
                                </div>
                            </div>
                        </Link>
                    </>
                    :<></>
                }
            </div>
        )
    }

    render (){
        const {data, metatags} = this.state;
        return(
            <DocumentMeta {...metatags}>
            <div className="home-page page">
            <LoadingBar height={4} color='#000' ref={this.state.ref} />
            {(data)?
                <>
                {this.renderHeadSection(data.hero_module)}
                {this.renderSection1(data.first_module)}
                {this.renderSection2(data.second_module)}
                {this.renderSection3(data.third_module)}
                {this.renderSection4(data.fourth_module)}
                {this.renderSection5(data.fifth_module)}
                {this.renderSection6(data.sixth_module)}
                </>
                : <></>
            }
            </div>
            </DocumentMeta>
        );
    }
}

// what props do i need to get from the state for this component?
const mapStateToProps = (state) => {
    // get the props needed for this component from the state of the store.
    return {
        langTxt: (state.lang && state.lang.text) || 'en',
        langUrl: (state.lang && state.lang.url) || '',
    }
}

// what events will occur that will change the state in this component
const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter( connect(mapStateToProps, mapDispatchToProps)(Home) );
